/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M4.5 6L7 4V4C8.78522 2.57183 9.67783 1.85774 10.6668 1.58413C11.5392 1.34279 12.4608 1.34279 13.3332 1.58413C14.3222 1.85774 15.2148 2.57183 17 4V4L19.5 6"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M19 5.60013L19.5 6.00013V6.00013C20.1097 6.48792 20.4146 6.73181 20.668 7.00532C21.3508 7.7424 21.7957 8.66808 21.9447 9.66171C22 10.0304 22 10.4208 22 11.2017V17.0001C22 19.7616 19.7614 22.0001 17 22.0001V22.0001C15.8954 22.0001 15 21.1047 15 20.0001V16.0001C15 14.3432 13.6569 13.0001 12 13.0001V13.0001C10.3432 13.0001 9.00001 14.3432 9.00001 16.0001V20.0001C9.00001 21.1047 8.10458 22.0001 7.00001 22.0001V22.0001C4.23858 22.0001 2.00001 19.7616 2.00001 17.0001V11.2017C2.00001 10.4208 2.00001 10.0304 2.0553 9.66171C2.20431 8.66808 2.64922 7.7424 3.33203 7.00532C3.5854 6.73181 3.89027 6.48792 4.50001 6.00013V6.00013L5.00001 5.60013"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M22 17V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V17C2 19.7614 4.23858 22 7 22C8.10457 22 9 21.1046 9 20V15.9999C9 14.3431 10.3431 12.9999 12 12.9999C13.6569 12.9999 15 14.3431 15 15.9999V20C15 21.1046 15.8954 22 17 22C19.7614 22 22 19.7614 22 17Z"
				fill="currentColor"
			/>
			<path
				d="M22 17V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V17C2 19.7614 4.23858 22 7 22C8.10457 22 9 21.1046 9 20V15.9999C9 14.3431 10.3431 12.9999 12 12.9999C13.6569 12.9999 15 14.3431 15 15.9999V20C15 21.1046 15.8954 22 17 22C19.7614 22 22 19.7614 22 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<g clipPath="url(#clip0_2004_11303)">
				<path
					d="M17.9971 3.83718C15.8568 2.12494 14.7866 1.26882 13.5998 0.940486C12.5529 0.650874 11.4471 0.650874 10.4002 0.940486C9.21339 1.26882 8.14324 2.12494 6.00293 3.83718L4.85293 4.75719C3.52983 5.81566 2.86828 6.3449 2.39209 7.00181C1.97024 7.58376 1.65638 8.23678 1.46548 8.92973C1.25 9.71194 1.25 10.5591 1.25 12.2535V17.5833C1.25 20.4368 3.5632 22.75 6.41667 22.75C7.8434 22.75 9 21.5934 9 20.1667V16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16V20.1667C15 21.5934 16.1566 22.75 17.5833 22.75C20.4368 22.75 22.75 20.4368 22.75 17.5833V12.2535C22.75 10.5591 22.75 9.71194 22.5345 8.92973C22.3436 8.23678 22.0298 7.58376 21.6079 7.00181C21.1317 6.3449 20.4702 5.81567 19.1471 4.75719L17.9971 3.83718Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11303">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M17 4.00486C14.7988 2.2705 13.4921 1.40332 12 1.40332C10.2461 1.40332 8.74843 2.60147 5.75306 4.99776L5.5487 5.16125C3.90733 6.47434 3.08665 7.13089 2.6045 8.02015C2.52697 8.16316 2.45646 8.30987 2.39322 8.45975C2.00002 9.39176 2.00002 10.4428 2.00002 12.5447V17.0002C2.00002 19.7616 4.23859 22.0002 7.00002 22.0002C8.10458 22.0002 9.00002 21.1048 9.00002 20.0002V16.0001C9.00002 14.3433 10.3432 13.0001 12 13.0001C13.6569 13.0001 15 14.3433 15 16.0001V20.0002C15 21.1048 15.8954 22.0002 17 22.0002C19.7614 22.0002 22 19.7616 22 17.0002V12.5447C22 10.4428 22 9.39176 21.6068 8.45975C21.5436 8.30987 21.4731 8.16316 21.3955 8.02015C21.0976 7.47061 20.6703 7.00994 20 6.42827"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M22 17V11.845C22 10.433 22 9.72701 21.8204 9.07517C21.6613 8.49771 21.3998 7.95353 21.0483 7.46857C20.6514 6.92115 20.1001 6.48011 18.9976 5.59805L16.9976 3.99805C15.214 2.57118 14.3222 1.85774 13.3332 1.58413C12.4608 1.34279 11.5392 1.34279 10.6668 1.58413C9.67783 1.85774 8.78603 2.57118 7.00244 3.99805L5.00244 5.59805C3.89986 6.48011 3.34857 6.92115 2.95174 7.46857C2.6002 7.95353 2.33865 8.49771 2.17957 9.07517C2 9.72701 2 10.433 2 11.845V17C2 19.7614 4.23858 22 7 22C8.10457 22 9 21.1046 9 20V15.9999C9 14.3431 10.3431 12.9999 12 12.9999C13.6569 12.9999 15 14.3431 15 15.9999V20C15 21.1046 15.8954 22 17 22C19.7614 22 22 19.7614 22 17Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<g clipPath="url(#clip0_2004_11300)">
				<path
					opacity="0.32"
					d="M17.9971 3.83721C15.8568 2.12496 14.7866 1.26884 13.5998 0.940508C12.5529 0.650897 11.4471 0.650897 10.4002 0.940508C9.21339 1.26884 8.14324 2.12496 6.00293 3.83721L4.85293 4.75721C3.52983 5.81569 2.86828 6.34493 2.39209 7.00183C1.97024 7.58378 1.65638 8.2368 1.46548 8.92976C1.25 9.71196 1.25 10.5592 1.25 12.2535V17.5834C1.25 20.4368 3.5632 22.75 6.41667 22.75C7.8434 22.75 9 21.5934 9 20.1667V16C9 14.3431 10.3431 13 12 13C13.6569 13 15 14.3431 15 16V20.1667C15 21.5934 16.1566 22.75 17.5833 22.75C20.4368 22.75 22.75 20.4368 22.75 17.5834V12.2535C22.75 10.5592 22.75 9.71196 22.5345 8.92976C22.3436 8.2368 22.0298 7.58378 21.6079 7.00183C21.1317 6.34493 20.4702 5.81569 19.1471 4.75721L17.9971 3.83721Z"
					fill="currentColor"
				/>
				<path
					d="M6.00293 3.83721L5 4.63955L6.62009 6.11162C8.52003 7.83798 9.47001 8.70116 10.5462 9.0282C11.494 9.31624 12.506 9.31624 13.4538 9.0282C14.53 8.70116 15.48 7.83798 17.3799 6.11163L19 4.63955L17.9971 3.83721C15.8568 2.12496 14.7866 1.26884 13.5998 0.940508C12.5529 0.650897 11.4471 0.650897 10.4002 0.940508C9.21339 1.26884 8.14324 2.12496 6.00293 3.83721Z"
					fill="currentColor"
				/>
			</g>
			<defs>
				<clipPath id="clip0_2004_11300">
					<rect width="24" height="24" fill="white" />
				</clipPath>
			</defs>
		</Fragment>,
	],
]);
